import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Package, Settings, LogOut, X, ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ isOpen, onClose }) => {
    const { userProfile, logout } = useAuth();
    
    const navItems = [
        { icon: LayoutDashboard, label: 'Mis Expedientes', path: '/dashboard' },
        { icon: FileText, label: '1. Bases y TDR', path: '/bases' },
        { icon: Package, label: '2. Ensamblaje', path: '/exportar' },
    ];

    if (userProfile?.role === 'admin') {
        navItems.unshift({ icon: ShieldAlert, label: 'Panel Admin', path: '/admin' });
    }

    return (
        <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <div style={{ width: '32px', height: '32px', background: 'hsl(var(--primary))', borderRadius: '8px' }}></div>
                    <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold', letterSpacing: '-0.5px' }}>El Gem SEACE</h1>
                </div>
                <button className="btn btn-ghost mobile-close-btn" onClick={onClose} style={{ color: 'white' }}>
                    <X size={24} />
                </button>
            </div>

            <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        onClick={onClose} // Close sidebar on navigation (mobile)
                        className={({ isActive }) =>
                            `btn btn-ghost ${isActive ? 'active' : ''}`
                        }
                        style={({ isActive }) => ({
                            justifyContent: 'flex-start',
                            gap: '0.75rem',
                            background: isActive ? 'rgba(255,255,255,0.1)' : 'transparent',
                            color: isActive ? 'white' : 'hsl(var(--secondary-foreground))',
                            opacity: isActive ? 1 : 0.7
                        })}
                    >
                        <item.icon size={20} />
                        {item.label}
                    </NavLink>
                ))}
            </nav>

            <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1rem', marginTop: 'auto' }}>
                {!userProfile?.sinConfiguracion && (
                    <NavLink
                        to="/settings"
                        onClick={onClose}
                        className={({ isActive }) => `btn btn-ghost ${isActive ? 'active' : ''}`}
                        style={({ isActive }) => ({
                            width: '100%',
                            justifyContent: 'flex-start',
                            gap: '0.75rem',
                            color: isActive ? 'white' : 'hsl(var(--secondary-foreground))',
                            opacity: isActive ? 1 : 0.7,
                            background: isActive ? 'rgba(255,255,255,0.1)' : 'transparent'
                        })}
                    >
                        <Settings size={20} />
                        Configuración
                    </NavLink>
                )}
                <button 
                    className="btn btn-ghost" 
                    onClick={async () => {
                        await logout();
                        window.location.href = '/';
                    }}
                    style={{ width: '100%', justifyContent: 'flex-start', gap: '0.75rem', color: '#ef4444', marginTop: '0.5rem', cursor: 'pointer' }}
                >
                    <LogOut size={20} />
                    Cerrar Sesión
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
